export const SHOW_MEMBERS_AREA_PAGE = 'SHOW_MEMBERS_AREA_PAGE'
